const isCommentSection = (
  s: PerformanceBoardTypes.SlideOut.SlideOutSection,
): s is PerformanceBoardTypes.SlideOut.CommentsSection => {
  return s.sectionType === 'Comments';
};

export default isCommentSection;
